
<div class="wrapper" tabindex="-1">
  <div class="menu-header">
    <button v-if="currentFolder.parentIsFolder" @click="lookUp" class="back">
      <span class="sr-only">Go Back to Parent Folder</span>
    </button>
    {{currentFolder.name}}
    <button @click="close($event)" class="btn-icon grey-to-red close">
      <span class="icon times"></span>
      <span class="sr-only">Close the context menu</span>
    </button>
  </div>
  <transition :name="contentName">
    <div class="content" :key="currentFolder.id">
      <ul>
        <li v-for="childFolder in currentFolder.folders">
          <button :key="childFolder.id"
                  @click="lookDown(childFolder)"
                  class="folder"
                  :disabled="isFolderButtonDisabled(childFolder)">
            <icon class="folder-closed" :class="{inactive: isFolderButtonDisabled(childFolder)}"></icon> <span>{{childFolder.name}}</span>
          </button>
        </li>
        <li v-for="childDocument in currentFolder.organizationDocumentsBy('title')">
          <div :key="childDocument.id" :class="StringHelper.camelToDash(childDocument.classKey)">
            <icon class="inactive" :class="StringHelper.camelToDash(childDocument.classKey)"></icon> <span>{{childDocument.title}}</span>
          </div>
        </li>
      </ul>
    </div>
  </transition>

  <transition name="slide-right">
    <div v-if="showAddFolder" class="menu-footer" :key="'Add Folder'">
      <div class="folder-name">
        <input v-model="newFolderName" ref="newFolderName" @keyup.enter="addFolder" @keyup.stop.esc="resetAddFolder"
               type="text"
               placeholder="Enter folder name...">
        <button @click="addFolder" class="check" >
          <span class="sr-only">Confirm New Folder Name</span>
        </button>
        <button @click="resetAddFolder" class="btn-icon grey-to-red close">
          <span class="icon times"></span>
          <span class="sr-only">Cancel New Folder Name</span>
        </button>
      </div>
    </div>
  </transition>
  <transition name="slide-left">
    <div v-if="!showAddFolder" class="menu-footer" :key="'Move Here'">
      <template v-if="this.options.selectOnly">
        <button @click="selectFolder" class="btn xs">
          Select
        </button>
      </template>
      <template v-else>
        <button @click="revealAddFolder" class="add-folder" :disabled="!$can('createDocumentsAndFolders', this.currentFolder)">
          <span class="sr-only">Create New Folder</span>
        </button>
        <button @click="moveHere" class="btn xs" :disabled="!$can('moveArchive', this.currentFolder)">
          Move here
        </button>
      </template>
    </div>
  </transition>

</div>
